<template>
  <div class="">
    <router-link
      class="mr-3 btn btn-info"
      :to="{
        path: `/Group/product-stock/details/${data.productID}/${data.productName}`,
        query: { groupId: $route.query.groupId, ...$route.query },
      }"
    >
    {{$t('text.clickButtons.details')}}
    </router-link>
    <router-link
      class="mr-3 btn btn-primary"
      :to="{
        name: 'GroupSupplyHistory',
        query: {
          productId: data.productID,
          productName: data.productName,
          groupId: $route.query.groupId,
          ...$route.query,
        },
      }"
    >
    {{$t('text.clickButtons.supplyHistory')}}
    </router-link>
    <router-link
      class="btn btn-warning"
      :to="{
        name: 'GroupSalesHistory',
        query: {
          productId: data.productID,
          productName: data.productName,
          groupId: $route.query.groupId,
          ...$route.query,
        },
      }"
    >
    {{$t('text.clickButtons.salesHistory')}}
    </router-link>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>
